const STATS = [
  'home_runs', 'obp', 'slg', 'ops', 'pitcher_wins', 'innings',
  'strikeouts', 'era', 'fantasy_points',
]
const AVERAGE_RUNS = 4.8
const HITTER_MODEL = {
  min: 5,
  max: 11,
  multiplier: 1.3,
  intercept: 4.19653068,
  coefs: {
    agg_home_runs: -1.92605836,
    ops: -2.44137262,
    fantasy_points: 0.71692996,
  },
  vegas_coef: EXPECTED_RUNS => {
    if(!EXPECTED_RUNS[0]) return 1
    return parseFloat(EXPECTED_RUNS[0]) / AVERAGE_RUNS
  },
}
const PITCHER_MODEL = {
  min: 8,
  max: 22,
  multiplier: 1,
  intercept: -0.25763546,
  coefs: {
    agg_pitcher_wins: -5.98326535e-01,
    agg_innings: 7.45259332e-01,
    agg_strikeouts: 1.74502789e+00,
    era: -4.98244119e-04,
    fantasy_points: 1.64949686e-01,
  },
  vegas_coef: EXPECTED_RUNS => {
    if(!EXPECTED_RUNS[1]) return 1
    return AVERAGE_RUNS / parseFloat(EXPECTED_RUNS[1])
  },
}

function processPlayerStats(stats = {}) {
  stats = Object.assign({}, stats)
  for(let key of STATS) {
    stats[key] = stats[key] || 0
  }

  stats.ops = stats.obp + stats.slg
  stats.fantasy_points = stats.fantasy_points / (stats.appearances || 1)
  stats.agg_home_runs = stats.home_runs / (stats.appearances || 1)
  stats.agg_pitcher_wins = stats.pitcher_wins / (stats.appearances || 1)
  stats.agg_innings = stats.innings / (stats.appearances || 1)
  stats.agg_strikeouts = stats.strikeouts / (stats.appearances || 1)

  return stats
}

function makePrice({ player, price, match, side, factors }) {
  const model = (player.position === 'pitcher') ? PITCHER_MODEL : HITTER_MODEL

  let playerLineup = match.lineups.find(p => p.player._id === player._id)
  if(playerLineup && playerLineup.xFP) {
    playerLineup.xFP = Math.max(
      model.min,
      Math.min(model.max, playerLineup.xFP))
    return playerLineup.xFP.toFixed(1)
  }

  const vegasCoef = model.vegas_coef(
    side
      ? match.expectedGoals.slice().reverse()
      : match.expectedGoals.slice()
  )
  let calculatedPrice = model.intercept
  for(let coef in model.coefs) {
    calculatedPrice += player.stats[coef] * model.coefs[coef]
  }
  calculatedPrice *= model.multiplier
  calculatedPrice *= Math.sqrt(vegasCoef)

  return Math.min(model.max, Math.max(model.min, calculatedPrice)).toFixed(1)
}

function getXfpFromProjection(projection) {
  let result
  if(projection['PositionCategory'] === 'P') {
    result = 4 * projection['Wins'] -
      2 * projection['PitchingEarnedRuns'] +
      2 * projection['PitchingStrikeouts'] +
      2.25 * projection['InningsPitchedDecimal'] -
      0.6 * projection['PitchingHits'] -
      0.6 * projection['PitchingWalks'] -
      0.6 * projection['PitchingHitByPitch'] +
      2.5 * projection['PitchingCompleteGames'] +
      2.5 * projection['PitchingShutOuts']
  } else {
    result = -1 * projection['Strikeouts'] +
      3 * projection['Singles'] + 5 * projection['Doubles'] +
      8 * projection['Triples'] + 10 * projection['HomeRuns'] +
      1.5 * projection['RunsBattedIn'] + 1.5 * projection['Runs'] +
      2.5 * projection['Walks'] + 4 * projection['StolenBases'] +
      2.5 * projection['HitByPitch'] - 3 * projection['CaughtStealing']
  }

  return result !== 0 && result
}

export default {
  processPlayerStats,
  makePrice,
  getXfpFromProjection,
};
